import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {JobTypeState} from "./JobTypeState";
import {JOB_TYPE_FETCHED, JOB_TYPE_UPDATED} from "../../action/jobType/actionType";

const initState: JobTypeState = {
	jobTypes: none
};

const reducer = handleActions({
	[JOB_TYPE_FETCHED]: (state: JobTypeState,
		action: Action<any>): JobTypeState => {
		return {...state, jobTypes: option(action.payload.jobTypes)}
	},
	[JOB_TYPE_UPDATED]: (state: JobTypeState,
		action: Action<JOB_TYPE_UPDATED>): JobTypeState => {
		const jobTypes = state.jobTypes.getOrElse([]).map(
			t => t.id == action.payload.jobType.id ? action.payload.jobType : t);
		return {...state, jobTypes: option(jobTypes)}
	},
}, initState);

export default reducer;
